module.exports = __webpack_public_path__ + "img/home-academy.85fbd9df.png";